import { Button } from 'reactstrap';
import React, { useState, useEffect } from 'react'
import MinimizableContainer from './MinimizableContainer';
import DocumentModal from './DocumentModal';
import { useDispatch, useSelector } from 'react-redux';
import ResearchKeyDropdown from './ResearchKeyDropdown';
import { useParams, useHistory } from "react-router-dom"
import { useQuery } from "react-query";
import getDocumentsValidated from '../../../api/getDocumentsValidated';
import deleteDocument from '../../../api/deleteDocument';
import { BiRefresh, BiDownload } from 'react-icons/bi';
import Loader from '../../utilities/loader';
import getDefaultDocument from '../../../api/getDefaultDocument';
import { Table, Tooltip } from 'antd';
import { showToastAction } from '../../../redux/toastSlice';
import filterValidatedDocuments from '../../../api/filterValidatedDocuments';
import '../../../index.css';
import getFormTemplate from '../../../api/getFormTemplate';
import { setFormType } from '../../../redux/selectedFormSlice';


const DocumentsValidated = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const selectedProject = useSelector(state => state.selectedProject);
    const selectedForm = useSelector(state => state.selectedForm);
    // const reloadDocuments = useSelector(state => state.reloadDocuments);
    const { form_name } = useParams();
    const { isLoading, data: documents, refetch } = useQuery("getDocumentsValidated" + selectedProject.name + form_name, () => getDocumentsValidated(selectedProject.name, form_name))

    // Récupérer le type de formulaire depuis l'API
    const { data: allForms } = useQuery(
        ["getFormTemplate", form_name],
        () => getFormTemplate(selectedProject.name, form_name),
        {
            enabled: !!selectedProject.name && !!form_name,
            onSuccess: (data) => {
                if (data?.data?.data?.[0]?.form_type) {
                    const formTypeFromAPI = data.data.data[0].form_type;
                    if (selectedForm.form_type !== formTypeFromAPI) {
                        dispatch(setFormType(formTypeFromAPI));
                    }
                }
            }
        }
    );

    // Mettre à jour le formType dans Redux quand il change
    useEffect(() => {
        if (allForms?.data?.data?.[0]?.form_type) {
            const formTypeFromAPI = allForms.data.data[0].form_type;
            if (selectedForm.form_type !== formTypeFromAPI) {
                dispatch(setFormType(formTypeFromAPI));
            }
        }
    }, [form_name, allForms?.data?.data, selectedForm.form_type, dispatch]);

    // Fonction pour rediriger vers la page d'édition
    const handleEditObject = (objectId) => {
        history.push(`/form/${form_name}/edit-object/${objectId}`);
    };


    // const [showPreferences, setShowPreferences] = useState(false);
    const [minimized, setMinimized] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [ModalType, setModalType] = useState("");
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [currentDataSource, setCurrentDataSource] = useState([]);
    const preferences = useSelector(state => state.preferences);
    const userState = useSelector(state => state.user)
    const preferencesArray = Object.entries(preferences)
    const filteredPreferences = preferencesArray.filter((el) => el[1] === true);
    const isAccessUser = (userState.user_type === 'CAPTURE' || userState.user_type === 'ADMIN' || userState.user_type === 'MASTER')

    const handleDownloadDoc = (id) => {
        getDefaultDocument(selectedProject.name, form_name, id).then((res) => {
            let type = res.data.type.split("/")
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `document.${type.at(-1)}`);
            document.body.appendChild(link);
            link.click();
        })
    }

    const [antTableCols, setAntTableCols] = useState([])
    const [uniqueFilters, setUniqueFilters] = useState([])

    // Function to format multiple values with commas
    const formatCellValue = (value) => {
        if (!value) return '';
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        if (typeof value === 'string' && value.includes(',')) {
            return value.split(',').map(item => item.trim()).join(', ');
        }
        return value;
    }

    useEffect(() => {
        let DataSource = currentDataSource.length > 0 ? currentDataSource : documents?.data?.data ?? []
        if (DataSource.length > 0) {
            let filters = Object.keys(DataSource[0]).map((item) =>
                ({ [item]: [...new Set(DataSource.map(mainItem => mainItem[item]))] })
            )

            setUniqueFilters(filters)
        }
    }, [documents?.data?.data, currentDataSource, filteredPreferences.toString()])


    useEffect(() => {
        // Filtrer les éléments 'all', 'TOUT SELECTIONNER' et '[object Object]'
        const validPreferences = filteredPreferences.filter(([key]) => key !== 'all' & key !== 'TOUT SELECTIONNER' && key !== '[object Object]');

        // Ne pas créer les colonnes tant que formType n'est pas défini
        if (!selectedForm.form_type) {
            return;
        }

        if (documents?.data?.data.length > 0 && uniqueFilters.length > 0) {
            let antTableColsStruct = [
                ...validPreferences.map(([key]) => {
                    return {
                        title: key,
                        dataIndex: key,
                        key: key,
                        width: `${100 / validPreferences.length}%`,
                        render: (_, record) => {
                            const formattedValue = formatCellValue(record[key]);
                            return (
                                <Tooltip title={formattedValue}>
                                    <div className='long-text-wrapper-div'>
                                        {formattedValue}
                                    </div>
                                </Tooltip>
                            );
                        },
                        sorter: (a, b) => a[key]?.localeCompare(b[key]),
                        filters: uniqueFilters.some((item) => Object.keys(item)[0] === key) ?
                            Object.values(uniqueFilters.find((item) => Object.keys(item)[0] === key)).flat()
                                .map((item) => ({ "text": item, "value": item })) : [],
                        onFilter: (value, record) => record[key]?.indexOf(value) === 0,
                    };
                }),
                {
                    title: 'Action',
                    key: 'action',
                    width: `${100 / validPreferences.length}%`,
                    render: (_, val) => {
                        
                        return (
                            <div className="d-flex"
                                style={{
                                    justifyContent: "flex-end",
                                    maxWidth: '230px',
                                    marginLeft: 'auto'
                                }}
                            >
                                {val.recycle && <button className="edit-btn recycle-btn" title="recycle" onClick={() => validate(val?._id, val)}><BiRefresh fontSize={30} /></button>}
                                
                                {/* Bouton Edit - affiché pour insertion_donnees et archivage_document */}
                                {(selectedForm.form_type === 'insertion_donnees' || selectedForm.form_type === 'archivage_document') && (
                                    <button
                                        disabled={!isAccessUser}
                                        onClick={() => selectedForm.form_type === 'insertion_donnees' ? handleEditObject(val._id) : handleShow(val)}
                                        className="edit-btn"
                                        title={isAccessUser ? "Edit" : "No access"}
                                    >
                                        <i className="ti-pencil-alt"></i>
                                    </button>
                                )}
                                
                                {/* Bouton Download - affiché seulement pour archivage_document */}
                                {selectedForm.form_type === 'archivage_document' && (
                                    <button className='edit-btn download-btn' title='download' onClick={() => handleDownloadDoc(val._id)}>
                                        <BiDownload fontSize={24} />
                                    </button>
                                )}
                                
                                <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                            </div>
                        );
                    },
                },
            ];
            setAntTableCols(antTableColsStruct);
        }
    }, [documents?.data?.data, uniqueFilters, filteredPreferences.toString(), selectedForm.form_type]);

    const formatterColumn = (data) => {
        return data ? <SmartText text={data} /> : '-'
    }

    const handleClose = () => {
        setShowModal(false)
        setSelectedDocument(null)
        refetch();
    };

    const handleShow = (document) => {
        // localStorage.setItem("TypeModal", "edit")
        setModalType("");
        setSelectedDocument(document)
        setShowModal(true);
    }

    const handleDeleteDocument = async (id) => {
        try {
            await deleteDocument(selectedProject.name, form_name, id)
            dispatch(showToastAction({ message: "Success", showToast: true, severity: "success" }))
            refetch();
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const validate = (id, val) => {
        // axios.post(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/document/${id}/recycle`).then(res => {
        // localStorage.setItem("TypeModal", "recycle")
        setModalType("recycle");
        setSelectedDocument(val)
        setShowModal(true);
        // history.push(`/recycledocs5/${window.location.pathname.split("/")[2]}/${id}`)
        // });
    }


    // useEffect(() => {
    //     refetch();
    // },[reloadDocuments]);

    const SmartText = ({ text, length = 20 }) => {
        const [showLess, setShowLess] = React.useState(true);

        if (text.length < length) {
            return <div>{text}</div>;
        }

        return (
            <div>
                {showLess ? text.slice(0, length) : text}
                {showLess ? <a href='' className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
                >....</a> : <a href='' className="read-or-hide" onMouseOver={() => setShowLess(true)}
                >...less</a>}
            </div>
        );
    };

    const onChange = (pagination, filters, sorter, extra) => {
        setAppliedFilters(filters)
        setCurrentDataSource(extra?.currentDataSource || [])
    };

    if (isLoading) return <><Loader /></>;

    const HandleDownload = () => {
        const downloadFilteredData = () => {
            let tempFilters = { ...appliedFilters }
            Object.keys(tempFilters).forEach((k) => tempFilters[k] == null && delete tempFilters[k]);

            let data = {
                "query": tempFilters
            }
            filterValidatedDocuments(selectedProject.name, form_name, data).then((res) => {
                if (res?.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `document.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                }
            })
        }

        return (
            <Button size="sm" onClick={() => downloadFilteredData()}>
                <i className="ti-download"></i>
            </Button>
        )
    }

    return (
        <>
            <MinimizableContainer
                // OptionsButton={() => ResearchKeyDropdown({ "documentsStatus": "VALIDATED" })}
                HandleDownload={() => HandleDownload()}
                className="form-documents mt-0"
                Title={Title}
                minimized={minimized}
                onMinimizeClick={() => setMinimized(!minimized)}
            >
                <DocumentModal
                    selectedDocument={selectedDocument}
                    show={showModal}
                    handleClose={handleClose}
                    ModalType={ModalType}
                    document_status={'VALIDATED'}
                />

                <div className="relative table_box">
                    {/* {documents?.data?.data?.length !== 0 &&
                        <BootstrapTable
                            keyField='_id'
                            data={documents?.data?.data}
                            columns={documentsColumns}
                            hover
                            headerClasses="header-class"
                        />
                    } */}

                    {documents?.data?.data?.length !== 0 && selectedForm.form_type && antTableCols.length > 0 &&
                        <>
                            <Table columns={antTableCols} dataSource={documents?.data?.data} onChange={onChange} pagination={false} />
                        </>
                    }
                    
                    {/* Affichage d'un message si formType n'est pas encore défini */}
                    {documents?.data?.data?.length !== 0 && !selectedForm.form_type && (
                        <div className="text-center p-4">
                            <p>Chargement du type de formulaire...</p>
                        </div>
                    )}
                </div>
            </MinimizableContainer></>
    )
}


function Title() {
    return <h3 style={{ marginBottom: 0, marginLeft: 12 }} className="heading">Documents archivés</h3>
}

export default DocumentsValidated
